/* tslint:disable */
/* eslint-disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse } from '@angular/common/http';
import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';
import { Observable } from 'rxjs';
import { map, filter } from 'rxjs/operators';

import { DataSourceLoadOptionsBase } from '../models/data-source-load-options-base';
import { DemandeEvacuationDto } from '../models/demande-evacuation-dto';
import { ImportErrorDto } from '../models/import-error-dto';
import { LoadResult } from '../models/load-result';


/**
 * Fonctions de gestion des demandes d'évacuation
 */
@Injectable({
  providedIn: 'root',
})
export class DemandesEvacuationService extends BaseService {
  constructor(
    config: ApiConfiguration,
    http: HttpClient
  ) {
    super(config, http);
  }

  /**
   * Path part for operation demandeEvacuationGetList
   */
  static readonly DemandeEvacuationGetListPath = '/api/demandes-evacuation/list';

  /**
   * Renvoie la liste des demandes d'évacuation.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `demandeEvacuationGetList()` instead.
   *
   * This method doesn't expect any request body.
   */
  demandeEvacuationGetList$Response(params?: {
  }): Observable<StrictHttpResponse<Array<DemandeEvacuationDto>>> {

    const rb = new RequestBuilder(this.rootUrl, DemandesEvacuationService.DemandeEvacuationGetListPath, 'get');
    if (params) {
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Array<DemandeEvacuationDto>>;
      })
    );
  }

  /**
   * Renvoie la liste des demandes d'évacuation.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `demandeEvacuationGetList$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  demandeEvacuationGetList(params?: {
  }): Observable<Array<DemandeEvacuationDto>> {

    return this.demandeEvacuationGetList$Response(params).pipe(
      map((r: StrictHttpResponse<Array<DemandeEvacuationDto>>) => r.body as Array<DemandeEvacuationDto>)
    );
  }

  /**
   * Path part for operation demandeEvacuationLoadList
   */
  static readonly DemandeEvacuationLoadListPath = '/api/demandes-evacuation/load-list';

  /**
   * Renvoie la liste des demandes d'évacuation (avec support pour groupement, filtrage, pagination et tri).
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `demandeEvacuationLoadList()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  demandeEvacuationLoadList$Response(params: {

    /**
     * Identifiant du parc
     */
    parcId?: number;

    /**
     * Paramètres de groupement, filtrage, pagination et tri
     */
    body: DataSourceLoadOptionsBase
  }): Observable<StrictHttpResponse<LoadResult>> {

    const rb = new RequestBuilder(this.rootUrl, DemandesEvacuationService.DemandeEvacuationLoadListPath, 'post');
    if (params) {
      rb.query('parcId', params.parcId, {});
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<LoadResult>;
      })
    );
  }

  /**
   * Renvoie la liste des demandes d'évacuation (avec support pour groupement, filtrage, pagination et tri).
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `demandeEvacuationLoadList$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  demandeEvacuationLoadList(params: {

    /**
     * Identifiant du parc
     */
    parcId?: number;

    /**
     * Paramètres de groupement, filtrage, pagination et tri
     */
    body: DataSourceLoadOptionsBase
  }): Observable<LoadResult> {

    return this.demandeEvacuationLoadList$Response(params).pipe(
      map((r: StrictHttpResponse<LoadResult>) => r.body as LoadResult)
    );
  }

  /**
   * Path part for operation demandeEvacuationGet
   */
  static readonly DemandeEvacuationGetPath = '/api/demandes-evacuation/{id}';

  /**
   * Renvoie la demande d'évacuation spécifiée.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `demandeEvacuationGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  demandeEvacuationGet$Response(params: {

    /**
     * Identifiant de la demande d&#x27;évacuation
     */
    id: number;
  }): Observable<StrictHttpResponse<DemandeEvacuationDto>> {

    const rb = new RequestBuilder(this.rootUrl, DemandesEvacuationService.DemandeEvacuationGetPath, 'get');
    if (params) {
      rb.path('id', params.id, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<DemandeEvacuationDto>;
      })
    );
  }

  /**
   * Renvoie la demande d'évacuation spécifiée.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `demandeEvacuationGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  demandeEvacuationGet(params: {

    /**
     * Identifiant de la demande d&#x27;évacuation
     */
    id: number;
  }): Observable<DemandeEvacuationDto> {

    return this.demandeEvacuationGet$Response(params).pipe(
      map((r: StrictHttpResponse<DemandeEvacuationDto>) => r.body as DemandeEvacuationDto)
    );
  }

  /**
   * Path part for operation demandeEvacuationPut
   */
  static readonly DemandeEvacuationPutPath = '/api/demandes-evacuation/{id}';

  /**
   * Met à jour la demande d'évacuation spécifiée.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `demandeEvacuationPut()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  demandeEvacuationPut$Response(params: {

    /**
     * Identifiant de la demande d&#x27;évacuation à mettre à jour
     */
    id: number;

    /**
     * Demande d'évacuation
     */
    body: DemandeEvacuationDto
  }): Observable<StrictHttpResponse<DemandeEvacuationDto>> {

    const rb = new RequestBuilder(this.rootUrl, DemandesEvacuationService.DemandeEvacuationPutPath, 'put');
    if (params) {
      rb.path('id', params.id, {});
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<DemandeEvacuationDto>;
      })
    );
  }

  /**
   * Met à jour la demande d'évacuation spécifiée.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `demandeEvacuationPut$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  demandeEvacuationPut(params: {

    /**
     * Identifiant de la demande d&#x27;évacuation à mettre à jour
     */
    id: number;

    /**
     * Demande d'évacuation
     */
    body: DemandeEvacuationDto
  }): Observable<DemandeEvacuationDto> {

    return this.demandeEvacuationPut$Response(params).pipe(
      map((r: StrictHttpResponse<DemandeEvacuationDto>) => r.body as DemandeEvacuationDto)
    );
  }

  /**
   * Path part for operation demandeEvacuationDelete
   */
  static readonly DemandeEvacuationDeletePath = '/api/demandes-evacuation/{id}';

  /**
   * Supprime la demande d'évacuation spécifiée.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `demandeEvacuationDelete()` instead.
   *
   * This method doesn't expect any request body.
   */
  demandeEvacuationDelete$Response(params: {

    /**
     * Identifiant de la demande d&#x27;évacuation à supprimer
     */
    id: number;
  }): Observable<StrictHttpResponse<number>> {

    const rb = new RequestBuilder(this.rootUrl, DemandesEvacuationService.DemandeEvacuationDeletePath, 'delete');
    if (params) {
      rb.path('id', params.id, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return (r as HttpResponse<any>).clone({ body: parseFloat(String((r as HttpResponse<any>).body)) }) as StrictHttpResponse<number>;
      })
    );
  }

  /**
   * Supprime la demande d'évacuation spécifiée.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `demandeEvacuationDelete$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  demandeEvacuationDelete(params: {

    /**
     * Identifiant de la demande d&#x27;évacuation à supprimer
     */
    id: number;
  }): Observable<number> {

    return this.demandeEvacuationDelete$Response(params).pipe(
      map((r: StrictHttpResponse<number>) => r.body as number)
    );
  }

  /**
   * Path part for operation demandeEvacuationPost
   */
  static readonly DemandeEvacuationPostPath = '/api/demandes-evacuation';

  /**
   * Crée la demande d'évacuation spécifiée.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `demandeEvacuationPost()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  demandeEvacuationPost$Response(params: {

    /**
     * Demande d'évacuation
     */
    body: DemandeEvacuationDto
  }): Observable<StrictHttpResponse<DemandeEvacuationDto>> {

    const rb = new RequestBuilder(this.rootUrl, DemandesEvacuationService.DemandeEvacuationPostPath, 'post');
    if (params) {
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<DemandeEvacuationDto>;
      })
    );
  }

  /**
   * Crée la demande d'évacuation spécifiée.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `demandeEvacuationPost$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  demandeEvacuationPost(params: {

    /**
     * Demande d'évacuation
     */
    body: DemandeEvacuationDto
  }): Observable<DemandeEvacuationDto> {

    return this.demandeEvacuationPost$Response(params).pipe(
      map((r: StrictHttpResponse<DemandeEvacuationDto>) => r.body as DemandeEvacuationDto)
    );
  }

  /**
   * Path part for operation demandeEvacuationSendEmail
   */
  static readonly DemandeEvacuationSendEmailPath = '/api/demandes-evacuation/email/{id}';

  /**
   * Envoie l'e-mail pour une demande d'évacuation.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `demandeEvacuationSendEmail()` instead.
   *
   * This method doesn't expect any request body.
   */
  demandeEvacuationSendEmail$Response(params: {

    /**
     * Identifiant de la demande d&#x27;évacuation pour laquelle l&#x27;e-mail doit être envoyé
     */
    id: number;
  }): Observable<StrictHttpResponse<DemandeEvacuationDto>> {

    const rb = new RequestBuilder(this.rootUrl, DemandesEvacuationService.DemandeEvacuationSendEmailPath, 'post');
    if (params) {
      rb.path('id', params.id, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<DemandeEvacuationDto>;
      })
    );
  }

  /**
   * Envoie l'e-mail pour une demande d'évacuation.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `demandeEvacuationSendEmail$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  demandeEvacuationSendEmail(params: {

    /**
     * Identifiant de la demande d&#x27;évacuation pour laquelle l&#x27;e-mail doit être envoyé
     */
    id: number;
  }): Observable<DemandeEvacuationDto> {

    return this.demandeEvacuationSendEmail$Response(params).pipe(
      map((r: StrictHttpResponse<DemandeEvacuationDto>) => r.body as DemandeEvacuationDto)
    );
  }

  /**
   * Path part for operation demandeEvacuationDownloadDemandes
   */
  static readonly DemandeEvacuationDownloadDemandesPath = '/api/demandes-evacuation/download';

  /**
   * Télécharge un modèle de fichier demandes d'évacuation pour un futur upload.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `demandeEvacuationDownloadDemandes()` instead.
   *
   * This method doesn't expect any request body.
   */
  demandeEvacuationDownloadDemandes$Response(params?: {
  }): Observable<StrictHttpResponse<Blob>> {

    const rb = new RequestBuilder(this.rootUrl, DemandesEvacuationService.DemandeEvacuationDownloadDemandesPath, 'get');
    if (params) {
    }

    return this.http.request(rb.build({
      responseType: 'blob',
      accept: 'application/octet-stream'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Blob>;
      })
    );
  }

  /**
   * Télécharge un modèle de fichier demandes d'évacuation pour un futur upload.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `demandeEvacuationDownloadDemandes$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  demandeEvacuationDownloadDemandes(params?: {
  }): Observable<Blob> {

    return this.demandeEvacuationDownloadDemandes$Response(params).pipe(
      map((r: StrictHttpResponse<Blob>) => r.body as Blob)
    );
  }

  /**
   * Path part for operation demandeEvacuationUploadDemandes
   */
  static readonly DemandeEvacuationUploadDemandesPath = '/api/demandes-evacuation/upload';

  /**
   * Upload du fichier demandes pour importer les évacuations.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `demandeEvacuationUploadDemandes()` instead.
   *
   * This method doesn't expect any request body.
   */
  demandeEvacuationUploadDemandes$Response(params?: {
  }): Observable<StrictHttpResponse<Array<ImportErrorDto>>> {

    const rb = new RequestBuilder(this.rootUrl, DemandesEvacuationService.DemandeEvacuationUploadDemandesPath, 'post');
    if (params) {
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Array<ImportErrorDto>>;
      })
    );
  }

  /**
   * Upload du fichier demandes pour importer les évacuations.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `demandeEvacuationUploadDemandes$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  demandeEvacuationUploadDemandes(params?: {
  }): Observable<Array<ImportErrorDto>> {

    return this.demandeEvacuationUploadDemandes$Response(params).pipe(
      map((r: StrictHttpResponse<Array<ImportErrorDto>>) => r.body as Array<ImportErrorDto>)
    );
  }

  /**
   * Path part for operation demandeEvacuationUploadDemandesFacture
   */
  static readonly DemandeEvacuationUploadDemandesFacturePath = '/api/demandes-evacuation/upload/facture';

  /**
   * Upload du fichier demandes facture pour importer les évacuations.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `demandeEvacuationUploadDemandesFacture()` instead.
   *
   * This method doesn't expect any request body.
   */
  demandeEvacuationUploadDemandesFacture$Response(params?: {
  }): Observable<StrictHttpResponse<Array<ImportErrorDto>>> {

    const rb = new RequestBuilder(this.rootUrl, DemandesEvacuationService.DemandeEvacuationUploadDemandesFacturePath, 'post');
    if (params) {
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Array<ImportErrorDto>>;
      })
    );
  }

  /**
   * Upload du fichier demandes facture pour importer les évacuations.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `demandeEvacuationUploadDemandesFacture$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  demandeEvacuationUploadDemandesFacture(params?: {
  }): Observable<Array<ImportErrorDto>> {

    return this.demandeEvacuationUploadDemandesFacture$Response(params).pipe(
      map((r: StrictHttpResponse<Array<ImportErrorDto>>) => r.body as Array<ImportErrorDto>)
    );
  }

  /**
   * Path part for operation demandeEvacuationExportDemandes
   */
  static readonly DemandeEvacuationExportDemandesPath = '/api/demandes-evacuation/export';

  /**
   * Télécharge l'export demandes des évacuations.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `demandeEvacuationExportDemandes()` instead.
   *
   * This method doesn't expect any request body.
   */
  demandeEvacuationExportDemandes$Response(params?: {
    isFacture?: boolean;
    dispatchTransporteurId?: number;
    typeEvacuationId?: number;
    month?: string;
  }): Observable<StrictHttpResponse<Blob>> {

    const rb = new RequestBuilder(this.rootUrl, DemandesEvacuationService.DemandeEvacuationExportDemandesPath, 'get');
    if (params) {
      rb.query('isFacture', params.isFacture, {});
      rb.query('dispatchTransporteurId', params.dispatchTransporteurId, {});
      rb.query('typeEvacuationId', params.typeEvacuationId, {});
      rb.query('month', params.month, {});
    }

    return this.http.request(rb.build({
      responseType: 'blob',
      accept: 'application/octet-stream'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Blob>;
      })
    );
  }

  /**
   * Télécharge l'export demandes des évacuations.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `demandeEvacuationExportDemandes$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  demandeEvacuationExportDemandes(params?: {
    isFacture?: boolean;
    dispatchTransporteurId?: number;
    typeEvacuationId?: number;
    month?: string;
  }): Observable<Blob> {

    return this.demandeEvacuationExportDemandes$Response(params).pipe(
      map((r: StrictHttpResponse<Blob>) => r.body as Blob)
    );
  }

}
